// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bbz_a bhi_kb","ListItemIcon--empty":"bbz_b bhi_fj"};